import { findAccountPlan } from './accountPlans';

// The plan picked on the Pricing page, carried through sign-up (including the
// Google redirect) to the first location's checkout.
const STORAGE_KEY = 'elonestPlanChoice';

export function savePlanChoice(plan, cycle) {
  if (!findAccountPlan(plan)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ plan, cycle: cycle === 'annual' ? 'annual' : 'monthly' }));
  } catch (error) {
    // Without storage the user picks the plan again on Billing.
  }
}

export function readPlanChoice() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    if (saved && findAccountPlan(saved.plan)) {
      return { plan: saved.plan, cycle: saved.cycle === 'annual' ? 'annual' : 'monthly' };
    }
  } catch (error) {
    // Fall through to no choice.
  }
  return null;
}

export function clearPlanChoice() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Nothing to clear.
  }
}

export function locationKindForPlan(plan) {
  return plan === 'personal' ? 'Personal' : 'LLC';
}
